import Mixcheck from './mixcheck.vue'

export default Mixcheck
